module.exports = __webpack_public_path__ + "static/img/home10.d736f54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home10.jpg
// module id = NosG
// module chunks = 0